import { WorkspacePanel } from './workspace-panel';

export type WorkspacePanelWithQueue = WorkspacePanel & {
    queue: Exclude<WorkspacePanel['queue'], undefined>;
};

export function workspacePanelIsQueue(
    workspacePanel: WorkspacePanel
): asserts workspacePanel is WorkspacePanelWithQueue {
    if (!workspacePanel.queue) {
        throw new Error('Unexpectedly did not find value for queue on WorkspacePanel');
    }
}
